import React from "react";
import { createRoot } from "react-dom/client";
import NextApp from "./NextApp";
import registerServiceWorker from "./registerServiceWorker";

const container = document.getElementById("root");
const root = createRoot(container); 

const render = (Component) => {
  root.render(<Component />);
};

// Do this once
registerServiceWorker();

// Initial render
render(NextApp);

// Hot Module Replacement (HMR)
if (module.hot) {
  module.hot.accept("./NextApp", () => {
    const NextAppReloaded = require("./NextApp").default;
    render(NextAppReloaded);
  });
}
